/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * Cell component for remove table row
 *
 * @author Anton Panasenko
 * @author Aleksandr Perkhunov
 * @version 1.4.0
 * @since 1.3.0
 */

import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { icons } from '../../../../../assets';
import { ImgStyled } from '../../../../common/Block/Img';
import { tableModalOpenRemove } from '../../../actions/tableActions';
import { ITableModalOpenRemoveActionPayload } from '../../../types/tableTypes';
import { TableRemoveRowButtonStyled } from '../styled/TableBlockStyled';


interface ITableRemoveRowBlockProps {
    rowId: number;
}

type TTableRemoveRowBlockProps = ITableRemoveRowBlockProps & IDispatchProps;

const TableRemoveRowBlock = (props: TTableRemoveRowBlockProps) => (
    <TableRemoveRowButtonStyled onClick={() => props.modalOpenRemove({ rowId: props.rowId })}>
        <ImgStyled className="big" src={icons.cancelIcon}/>
    </TableRemoveRowButtonStyled>
)

interface IDispatchProps {
    modalOpenRemove: (payload: ITableModalOpenRemoveActionPayload) => void;
}

const mapDispatchToProps = (dispatch: Dispatch): IDispatchProps => ({
    modalOpenRemove: payload => dispatch(tableModalOpenRemove(payload)),
});

export default connect(undefined, mapDispatchToProps)(TableRemoveRowBlock);
